import _ from 'lodash';
import { fromJsonArray } from 'src/core/utils';
import Pageable from 'src/entities/basic-types/Pageable';
import { CustomerBill, CustomerBillInfo } from 'src/entities/customer/CustomerBill';
import { CustomerCommissionBill, CustomerCommissionBillInfo } from 'src/entities/customer/CustomerCommissionBill';
import {
    CustomerDownload,
    CustomerDownloadTopic,
    CustomerLocalizedDownload,
} from 'src/entities/customer/CustomerDownload';
import { entityCollectionDefaultState, EntityCollectionState } from 'src/store/entities/types/EntityCollectionState';
import { singleEntityDefaultState, SingleEntityState } from 'src/store/entities/types/SingleEntityState';

/* Customer Download Topics */
export const getCustomerDownloadTopics = (state: any): EntityCollectionState<CustomerDownloadTopic> => {
    const data = state.customerDownloadTypes;

    if (_.isEmpty(data)) return entityCollectionDefaultState<CustomerDownloadTopic>();

    return {
        isFetching: data.isFetching,
        error: data.error,
        items: fromJsonArray(CustomerDownloadTopic, data.items),
    };
};

/* Customer Downloads */
export const getCustomerDownloads = (state: any): SingleEntityState<Pageable<CustomerDownload>> => {
    const data = state.customerDownloads;
    if (_.isEmpty(data)) return singleEntityDefaultState<Pageable<CustomerDownload>>();

    return {
        isFetching: data.isFetching,
        error: data.error,
        content: data.content ? new Pageable(CustomerDownload, data.content) : undefined,
    };
};

/* Customer Localized Downloads */
export const getCustomerLocalizedDownloads = (state: any): EntityCollectionState<CustomerLocalizedDownload> => {
    const data = state.customerLocaliziedDownloads;
    if (_.isEmpty(data)) return entityCollectionDefaultState<CustomerLocalizedDownload>();

    return {
        isFetching: data.isFetching,
        error: data.error,
        items: fromJsonArray(CustomerLocalizedDownload, data.items),
    };
};

/* Customer Bills Info */
export const getCustomerBillsInfo = (state: any): EntityCollectionState<CustomerBillInfo> => {
    const data = state.customerBillsInfo;
    if (_.isEmpty(data)) return entityCollectionDefaultState<CustomerBillInfo>();

    return {
        isFetching: data.isFetching,
        error: data.error,
        items: fromJsonArray(CustomerBillInfo, data.items),
    };
};

/* Customer Bills */
export const getCustomerBills = (state: any): SingleEntityState<Pageable<CustomerBill>> => {
    const data = state.customerBills;
    if (_.isEmpty(data)) return singleEntityDefaultState<Pageable<CustomerBill>>();

    return {
        isFetching: data.isFetching,
        error: data.error,
        content: data.content ? new Pageable(CustomerBill, data.content) : undefined,
    };
};

/* Customer Commission Bills Info */
export const getCustomerCommissionBillsInfo = (state: any): EntityCollectionState<CustomerCommissionBillInfo> => {
    const data = state.customerCommissionBillsInfo;
    if (_.isEmpty(data)) return entityCollectionDefaultState<CustomerCommissionBillInfo>();

    return {
        isFetching: data.isFetching,
        error: data.error,
        items: fromJsonArray(CustomerCommissionBillInfo, data.items),
    };
};
/* Customer Commission Bills */
export const getCustomerCommissionBills = (state: any): SingleEntityState<Pageable<CustomerCommissionBill>> => {
    const data = state.customerCommissionBills;
    if (_.isEmpty(data)) return singleEntityDefaultState<Pageable<CustomerCommissionBill>>();

    return {
        isFetching: data.isFetching,
        error: data.error,
        content: data.content ? new Pageable(CustomerCommissionBill, data.content) : undefined,
    };
};
